(function(EF, undefined) {

  var Answer = Backbone.Model.extend({});

  _.extend(EF.Models, {
    Answer: Answer
  });

}(EF));
